export type ViewType = 'map' | 'card' | 'table' | 'grid' | 'summary';

export interface CardDisplayField {
  field: string;
  label: string;
}

export const getBadgeIndicatorColor = (badgeText: string): string => {
  const text = badgeText.toLowerCase();

  if (
    text.includes('fire') ||
    text.includes('damage') ||
    text.includes('detected') ||
    text.includes('warning') ||
    text.includes('alert') ||
    text.includes('hazard')
  ) {
    return 'orange';
  }

  if (
    text.includes('critical') ||
    text.includes('severe') ||
    text.includes('emergency') ||
    text.includes('destroyed') ||
    text.includes('high risk')
  ) {
    return 'red';
  }

  if (
    text.includes('water') ||
    text.includes('flood') ||
    text.includes('storm') ||
    text.includes('track') ||
    text.includes('hurricane') ||
    text.includes('idalia')
  ) {
    return 'blue';
  }

  if (
    text.includes('undamaged') ||
    text.includes('safe') ||
    text.includes('clear') ||
    text.includes('detection') ||
    text.includes('monitoring')
  ) {
    return 'green';
  }

  return 'green';
};

export const getDetailsLink = (
  detailsPagePath: string,
  uuid: string,
): string => {
  const basePath = detailsPagePath.startsWith('/')
    ? detailsPagePath
    : `/${detailsPagePath}`;
  return `${basePath}?id=${uuid}`;
};
